import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileTopBar from './MobileTopBar';
import MobileTabBar from './MobileTabBar';
import OnboardingTour from '../onboarding/OnboardingTour';
import { useIsMobile } from '../../hooks/useIsMobile';

export default function Layout() {
  const [selectedMarket, setSelectedMarket] = useState(() => {
    const market = new URLSearchParams(window.location.search).get('market')?.toLowerCase();
    return market === 'us' ? 'US' : 'CN';
  });
  const isMobile = useIsMobile();

  const loading = (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">加载中...</p>
      </div>
    </div>
  );

  if (isMobile) {
    // 移动壳:精简顶栏 + 底部标签栏,内容区留出底部标签栏高度(含 iOS 安全区)
    return (
      <div className="min-h-screen flex flex-col bg-gray-50">
        <OnboardingTour />
        <MobileTopBar selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} />
        <main className="flex-1 pb-[calc(64px+env(safe-area-inset-bottom))]">
          <Suspense fallback={loading}>
            <Outlet context={{ selectedMarket }} />
          </Suspense>
        </main>
        <MobileTabBar />
      </div>
    );
  }

  // 桌面壳(原样)
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <OnboardingTour />
      <Header selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto bg-gray-50">
          <Suspense fallback={loading}>
            <Outlet context={{ selectedMarket }} />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
